
<template>

  <div>

    <img :src="`https://makesolutions.kr/uploads/1.png`" >

    <img src="https://makesolutions.kr/uploads/1.png" >

<!--    <img src="{require('https://makesolutions.kr/uploads/1.png')}" />-->

<!--    <div class="mainBody"-->
<!--         v-bind:style="{ backgroundImage: 'url(https://makesolutions.kr/'+ this.rfidGetOrderSeq +'.png)' }"-->
<!--         v-if="successFlag">-->


      <div class="mainBody"
           v-bind:style="{ backgroundImage: 'url(https://makesolutions.kr/'+ this.rfidGetOrderSeq +'.png)' }"
           v-if="successFlag">


      <el-row>

        <img style="float: right ; margin-top:20px;  margin-right: 30px"  width="30" src="./assets/images.png" @click="dialogVisible = true">

        <div class="gifImage"
             v-bind:style="{ backgroundImage: 'url(https://makesolutions.kr/2_1.gif)' }"
             v-if="successFlag2">
        </div>

      </el-row>



      <!--      <el-button-->
<!--          :loading="loading"-->
<!--          type="primary"-->
<!--          @click="dialogVisible = true"-->
<!--          v-bind:style="{ 'background': this.buttonColor , 'border-color':  this.buttonBoderColor , 'margin-left' : '5px', 'margin-top' : '10px'}"-->
<!--          v-if="successFlag3"-->
<!--      >이용약관</el-button>-->




      <div class="center">

        <div class="box">

          <el-row>

            <div :style=" { marginTop: deviceML + 'vh'}" >
              <br>
            </div>


            <!-- 스킨천사 -->
            <div  v-if="successFlag2" >
              <el-button id="elButton" type="danger" round class="menu-button"  > {{ this.authKey }}</el-button>
              <br><br>
              <el-button id="elButton" type="danger" round class="menu-button"  >COUNTING : {{ this.checkCount }}</el-button>
              <br><br>
              <el-button id="elButton" type="danger" round class="menu-button" @click="linkUrl1()"  >
                {{ this.link_message_1  }} </el-button>
              <br><br>
              <el-button id="elButton" type="danger" round class="menu-button"  @click="linkUrl2()"   >
                {{ this.link_message_2  }}  </el-button>
            </div>


            <!-- 일반 전체 -->
            <div  v-if="successFlag3" >

              <div  v-if="authGubun1" >
              <el-button v-bind:style="{ 'background': this.buttonColor , 'border-color':  this.buttonBoderColor }"  round class="menu-button"  > {{ this.authKey }}</el-button>
              <br><br>
              </div>

              <div  v-if="authGubun2Step1" >
                <el-button type="warning" round class="menu-button" @click="registration()" > 정품등록 (Genuine Registration)</el-button>
                <br><br>
              </div>


              <el-button  v-bind:style="{ 'background': this.buttonColor , 'border-color':  this.buttonBoderColor }"    round class="menu-button"  >COUNTING : {{ this.checkCount }}</el-button>
              <br><br>
              <el-button v-bind:style="{ 'background': this.buttonColor , 'border-color':  this.buttonBoderColor }"   round class="menu-button" @click="linkUrl1()"  >
                {{ this.link_message_1  }} </el-button>
              <br><br>
              <el-button v-bind:style="{ 'background': this.buttonColor , 'border-color':  this.buttonBoderColor }"   round class="menu-button"  @click="linkUrl2()"   >
                {{ this.link_message_2  }}  </el-button>
            </div>




          </el-row>
        </div>
      </div>
    </div>


    <!-- fail START -->
    <div class="mainBody"
         v-if="failFlag"
         v-bind:style="{ backgroundImage: 'url(' + this.failImage+ ')' }"
    >
    </div>
    <!-- fail END -->

    <!-- 인증구분 2  START -->
    <div class="mainBody"
         v-if="authGubun2Step2"
    >

      <el-row>
        <div class="gifImage2"
             v-bind:style="{ backgroundImage: 'url(https://makesolutions.kr/2_1.gif)'  }"
             style="height: 30vh "
             >
        </div>
      </el-row>


      <div class="center">
        <div class="box">
          <el-row>

            <div :style=" { marginTop: deviceML + 'vh'}"

            >
              <br>
            </div>
            <div class="searchBody">
              <div style="margin-left: 0px ;color:black; width:35vw" >
                일련번호(Serial Number)  :
              </div>
              <div >
                <el-input id ='inputForm'  v-model="authCode"  :disabled="true"  > {{this.authCode}}  </el-input>



              </div>
            </div>
            <br>
            <div class="searchBody">
              <div style="margin-left: 0px ;color:black; width:35vw" >
                성함(Name)  :
              </div>
              <div >
                <el-input id ='inputForm'  v-model="phoneNumber"  ></el-input>
              </div>
            </div>
            <br>
            <div class="searchBody">
              <div style="margin-left: 0px ;color:black; width:35vw" >
                연락처(Mobile Number)  :
              </div>
              <div >
                <el-input id ='inputForm'  v-model="email"  ></el-input>
              </div>
            </div>
            <br>
            <div class="searchBody">
              <div style="margin-left: 0px ;color:black; width:35vw" >
                E-Mail :
              </div>
              <div >
                <el-input id ='inputForm'  v-model="productName"  ></el-input>
              </div>
            </div>
            <br>
<!--            <div class="searchBody">-->
<!--              <div style="margin-left: 0px ;color:black; width:35vw" >-->
<!--                구입국가(Country of Purchase) :-->
<!--              </div>-->
<!--              <div >-->
<!--                <el-input id ='inputForm'  v-model="saleName"  ></el-input>-->
<!--              </div>-->
<!--            </div>-->
<!--            <br>-->
<!--            <div class="searchBody">-->
<!--              <div style="margin-left: 0px ;color:black; width:35vw" >-->
<!--                구매제품명(Product Name) :-->
<!--              </div>-->
<!--              <div >-->
<!--                <el-input id ='inputForm'  v-model="saleName"  ></el-input>-->
<!--              </div>-->
<!--            </div>-->
<!--            <br>-->

            <div class="searchBody">
              <div style="margin-left: 0px ;color:black; width:35vw" >
                구매날짜(Purchase Date) :
              </div>
              <div >
                <el-input id ='inputForm'  v-model="saleName"  ></el-input>
              </div>
            </div>
            <br>

            <div >
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 5}"
                    placeholder="Please input"
                    v-model="textarea">
            </el-input>
            </div>
            <br>

            <div class="searchBody">
            <el-checkbox v-model="checked">개인정보 수집 약관에 동의합니다. [필수] </el-checkbox>
            </div>
            <br>

            <div class="searchBody">
              <el-button id="elButton" type="warning" round class="menu-button"  @click="save()"    >
                정품 등록
              </el-button>
            </div>


          </el-row>
        </div>
      </div>
    </div>
    <!-- 인증구분 2  END -->


    <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="70%"
        height="500px"
        v-loading="loading"
        :before-close="Confirm"
    >

      <el-row  class="row-bg" >
        <el-col :span="23">
          <div class="grid-content5">

              <el-input
                  type="textarea"
                  :autosize="{ minRows: 30, maxRows: 30}"
                  placeholder="Please input"
                  v-model="textarea2"
                  style="text-align: left; "
              >
              </el-input>

          </div>
        </el-col>
      </el-row >

      </el-dialog>



  </div>
</template>

<script>
import Axios from 'axios';

export default {

  created() {

    // console.log ("this.$route.query.url : "+ this.$route.query.url);

    if (this.$route.query.url != null ) {

      console.log ("this.$route.query.url : "+ this.$route.query.url);

      const url = this.$route.query.url;

      this.$router.push({ name: url })

      return;
    }

    var lang = navigator.language


    if (this.$route.query.Auth != null ) {

      this.authCode =  this.$route.query.Auth


      if (lang.toLowerCase() == "zh-cn" || lang.toLowerCase()  == "zh-cn" || lang.toLowerCase()  == "zh-sg"  || lang.toLowerCase()  == "zh-sg"  || lang.toLowerCase()  == "zh-tw"
          || lang.toLowerCase()  == "zh" || this.authCode.substring(2,4) == '14'
      ){
        this.geolocate2();
      }else {
        this.geolocate2();

        // this.geolocate();
      }
    }
    else if (this.$route.query.A != null ) {

      console.log(this.authCode.substring(2,2));


      this.authCode =  this.$route.query.A;


      if (lang.toLowerCase() == "zh-cn" || lang.toLowerCase()  == "zh-cn" || lang.toLowerCase()  == "zh-sg"  || lang.toLowerCase()  == "zh-sg"  || lang.toLowerCase()  == "zh-tw"
          || lang.toLowerCase()  == "zh" || this.authCode.substring(2,4) == '14'
      ){

        this.geolocate2();

      }else {
        this.geolocate2();

        // this.geolocate();
      }
    } else if (this.$route.query.reg != null ) {

      this.reg();
    }
    else {
      this.$router.push({ name: 'Login' });
    }


    // this.successFlag3 = true;
    // this.successFlag = true;
    // this.successFlag2 = true;


    this.textarea2 = "이용약관\n" +
  "MICRO-CHECK 서비스 이용약관\n" +
  "\n" +
  "시행일 : 2022년 06월 21일\n" +
  "\n" +
  "제1조 (목적)\n" +
  "본 약관은 주식회사 메이크솔루션스(이하 “회사”라 한다)가 운영하는 “MICRO-CHECK”(이하 “서비스”라 한다)를 이용함에 있어 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.\n" +
  "\n" +
  "제2조 (정의)\n" +
  "1. “MICRO-CHECK”이란 소비자의 상품 구입 전, 후 상품의 위조 여부를 스마트폰 카메라를 통하여 상품에 부착되어 있는 QR코드를 인식, 확인하는 서비스를 말합니다.\n" +
  "2. “이용자”란 주식회사 메이크솔루션스의 “MICRO-CHECK”이 제공하는 서비스를 받는 모든 이용자를 말합니다.\n" +
  "\n" +
  "제3조 (MICRO-CHECK 서비스 이용계약의 체결)\n" +
  "MICRO-CHECK 서비스 이용계약은 주식회사 “MICRO-CHECK” 이용약관에 동의를 통해 즉시 서비스 이용계약이 체결되며, 회사는 즉시 서비스를 제공합니다.\n" +
  "\n" +
  "제4조 (이용약관의 명시와 설명 및 개정)\n" +
  "1. 이용자가 “MICRO-CHECK” 서비스를 통해 본 약관의 동의함을 수락하였을 경우 본 약관의 전체 내용을 모두 숙지하였으며 그 적용에 동의한 것으로 봅니다.\n" +
  "2. “회사”는 이용자가 약관에 동의하기에 앞서 별도의 화면으로 약관에 대한 전체 내용을 제공합니다.\n" +
  "3. “회사”는 「약관의 규제에 관한 법률」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 등 관련 법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.\n" +
  "4. “회사”가 본 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 “MICRO-CHECK”의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만, 이용자에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다. 이 경우 회사는 개정 전 내용과 개정 후 내용을 명확하게 비교하여 이용자가 알기 쉽도록 표시합니다.\n" +
  "\n" +
  "5. 본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대해서는 관계법령 또한 상관례에 따릅니다.\n" +
  "\n" +
  "제5조 (MICRO-CHECK 서비스의 제공 및 변경)\n" +
  "“MICRO-CHECK”은 아래와 같은 서비스를 제공합니다.\n" +
  "1. 이용자가 구매한 상품의 정품 여부를 스마트폰을 이용하여 확인하는 서비스\n" +
  "2. 인증 결과에 따른 구입한 제품 및 기업의 정보 제공\n" +
  "3. 위치정보를 이용하여 상품의 일련번호와 대조, 물류 및 유통관리 서비스 제공\n" +
  "4. 위치정보를 이용하여 위조 제품의 생산 및 판매가 의심되는 위치에 대한 정보 제공\n" +
  "\n" +
  "제6조 (MICRO-CHECK 서비스의 중단)\n" +
  "1. “회사”는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.\n" +
  "2. “회사”는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, 회사가 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.\n" +
  "\n" +
  "제7조 (개인정보보호)\n" +
  "1. “회사”는 이용자의 개인정보 수집 시 서비스 제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다.\n" +
  "2. “회사”는 개인정보를 수집•이용하는 때에는 당 해 이용자에게 그 목적을 고지하고 동의를 받습니다.\n" +
  "3. “회사”는 수집된 개인정보를 목적 외의 용도로 이용할 수 없으며, 새로운 이용목적이 발생한 경우 또는 제3자에게 제공하는 경우에는 이용•제공단계에서 당해 이용자에게 그 목적을 고지하고 동의를 받습니다. 다만, 관련 법령에 달리 정함이 있는 경우에는 예외로 합니다.\n" +
  "4. “회사”는 개인정보를 제공받은 제 3자가 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기합니다.\n" +
  "\n" +
  "제8조 (개인정보 처리 및 목적)\n" +
  "개인정보보호법 제 13조에 의거 “회사”는 스마트폰을 통하여 서비스의 제공 및 이용 고객과의 민원처리를 위해 위치정보, 상품의 사진, 단말의 고유번호 등 자료를 기록, 보존 하며 관계법령 소비자의 불만 또는 분쟁처리에 관한 기록 1년간 보관 후 파기 합니다.\n" +
  "\n" +
  "제9조 (위치정보의 이용)\n" +
  "1. 회사는 위치정보를 수집하여 아래와 같은 위치기반서비스를 제공합니다.\n" +
  "① 위치정보를 이용하여 상품의 일련번호와 대조, 유통관리 서비스 제공\n" +
  "② 위치정보를 이용하여 위조 제품의 생산 및 판매 위치에 대한 정보를 수집\n" +
  "\n" +
  "제10조 (개인위치정보주체의 권리)\n" +
  "1. 개인위치정보주체는 개인위치정보 수집 범위 및 이용약관의 내용 중 일부 또는 개인위치정보의 이용ㆍ제공 목적, 제공받는 자의 범위 및 위치기반서비스의 일부에 대하여 동의를 유보할 수 있습니다.\n" +
  "2. 개인위치정보주체는 개인위치정보의 수집ㆍ이용ㆍ제공에 대한 동의의 전부 또는 일부를 철회할 수 있습니다.\n" +
  "3. 개인위치정보주체는 언제든지 개인위치정보의 수집ㆍ이용ㆍ제공의 일시적인 중지를 요구할 수 있습니다. 이 경우 회사는 요구를 거절하지 아니하며, 이를 위한 기술적 수단을 갖추고 있습니다.\n" +
  "4. 개인위치정보주체는 회사에 대하여 아래 자료의 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다.\n" +
  "이 경우 회사는 정당한 이유 없이 요구를 거절하지 아니합니다.\n" +
  "① 개인위치정보주체에 대한 위치정보 수집ㆍ이용ㆍ제공사실 확인자료\n" +
  "② 개인위치정보주체의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법령의 규정에 의하여 제3자에게 제공된 이유 및 내용\n" +
  "\n" +
  "5. 회사는 개인위치정보주체가 동의의 전부 또는 일부를 철회한 경우에는 지체 없이 수집된 개인위치정보 및 위치정보 수집ㆍ이용ㆍ제공사실 확인자료를 파기합니다. 단, 동의의 일부를 철회하는 경우에는 철회하는 부분의 개인위치정보 및 위치정보 수집ㆍ이용ㆍ제공사실 확인자료에 한합니다.\n" +
  "6. 개인위치정보주체는 제1항 내지 제4항의 권리행사를 위하여 이 약관 제12조의 연락처를 이용하여 회사에 요구할 수 있습니다.\n" +
  "\n" +
  "제11조 (위치정보 이용ㆍ제공사실 확인자료 보유근거 및 보유기간)\n" +
  "1. 회사는 위치정보의 보호 및 이용 등에 관한 법률 제16조 제2항에 근거하여 개인위치정보주체에 대한 위치정보 수집ㆍ이용ㆍ제공사실 확인자료를 위치정보시스템에 자동으로 기록하며, 1년간 보관 후 파기합니다.\n" +
  "\n" +
  "제12조 (이용자의 의무) 이용자는 다음 행위를 하여서는 안 됩니다.\n" +
  "1. “MICRO-CHECK” 및 기타 제 3자의 저작권 등 지적재산권에 대한 침해\n" +
  "2. “MICRO-CHECK” 및 기타 제 3자의 명예를 손상시키거나 업무를 방해하는 행위\n" +
  "\n" +
  "제13조 (분쟁조정)\n" +
  "1. 회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 위치정보의 보호 및 이용 등에 관한 법률 제28조의 규정에 의한 방송통신위원회에 재정을 신청할 수 있습니다.\n" +
  "2. 회사 또는 고객은 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 개인정보보호법 제 43조의 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.\n" +
  "\n" +
  "제14조 (사업자 연락처)\n" +
  "회사 사업자 정보는 아래와 같습니다.\n" +
  "1. 상 호 : 주식회사 메이크솔루션스(MAKE SOLUTIONS Inc.)\n" +
  "2. 대표자 : 최지현\n" +
  "3. 주 소 : 경기도 성남시 중원구 광명로 377, 신구대학교 창업관 306호\n" +
  "4. 대표전화 : 0507-1441-1505\n" +
  "\n" +
  "\n" +
  "부 칙\n" +
  "\n" +
  "제1조 (시행일) 이 약관은 2022년 06월 21일부터 시행한다.\n" +
  "제2조 위치정보관리책임자는 2022년 6월을 기준으로 다음과 같이 지정합니다.\n" +
  "1. 소 속 : IT개발본부\n" +
  "2. 대표전화 : 0507-1441-1505"




  },
  data(){
    return {
      authCode : '',
      authKey : '',
      chkFlag : '',
      checkCount : '',
      latitude : '',
      longitude : '',
      successFlag : false ,
      failFlag : false,
      mainDiv : 'mainBody1',
      imagePath : 'http://localhost:8080/assets/pda_main.png',
      link_message_1  : '',
      link_url_1  : '',
      link_message_2  : '',
      link_url_2  : '',
      rfidGetOrderSeq : 0,
      failImage : 'https://makesolutions.kr/fail_0.png',
      successFlag2 : false,
      successFlag3 : true,
      successFlag4 : false,
      successFlag5 : false,
      successFlag8 :false,
      deviceML: '90',

      authGubun1 : false,

      authGubun2 : false,
      authGubun2Step2 : false,
      authGubun2Step1 : false,
      userName : '',
      phoneNumber : '',
      email : '',
      productName : '',
      saleName : '',
      buttonColor : '#909399',
      buttonBoderColor : '#909399',
      textarea : '',
      textarea2 : '',
      checked:true,
      dialogVisible : false,
      // imgSrc: require('https://makesolutions.kr/uploads/1.png'),



    }
  },
  methods:{

    // mounted() {
    //   this.geolocate();
    // },

    getContentImageLink(video_image) {
      return this.$http.options.root  + video_image+ '1.png';
    },

    registration(){

      if (this.link_url_1 == null || this.link_url_1 == "")
      {
        console.log ("Is null ");
      }else {
        window.location.href = "/?reg=" + this.authCode + "&seq=" + this.rfidGetOrderSeq
      }

    },

    reg(){

      this.authCode = this.$route.query.reg;
      this.rfidGetOrderSeq = this.$route.query.seq;
      this.deviceML = 10;
      this.authGubun2Step2 = true;

      this.textarea = "개인정보보호법 등 관련 법규에 의거하여 (주)메이크솔루션스는 개인정보 수집 활용 동의서를 받고 있습니다. 신청자께서는 하기 내용에 따라 개인정보 제공 동의를 거부하실 수 있으며, 거부 시 정품등록은 완료되지 않습니다.\n" +
          "\n" +
          "제공된 개인 정보는 개인정보 제공자가 동의한 내용 외의 다른 목적으로 활용되지 않습니다. 제공된 개인정보의 이용을 거부하고자 할 때에는 개인정보 관리책임자를 통해 열람,정정,삭제를 요구할 수 있습니다.\n" +
          "제공된 개인 정보는 정품등록에 관한 아래 항목에 제한된 범위에서만 활용됩니다.\n" +
          "\n" +
          "\n" +
          "[개인정보 수집항목]\n" +
          "1. 이름\n" +
          "2. 연락처\n" +
          "3. E-mail\n" +
          "\n" +
          "[개인정보 이용 목적]\n" +
          "이름, 연락처, E-mail : 정품제품 등록자와 주문자의 매칭 및 본인 식별 절차에 활용\n" +
          "\n" +
          "[개인정보 보유 기간]\n" +
          "정품등록 후 2년"



    },

    linkUrl1(){

      if (this.link_url_1 == null || this.link_url_1 == "")
      {
        console.log ("Is null ");
      }else {
        window.location.href = this.link_url_1;
      }

    },

    linkUrl2(){

      if (this.link_url_2 == null || this.link_url_2 == "")
      {
        console.log ("Is null ");
      }else {
        window.location.href = this.link_url_2;
      }
      // window.location.href = this.link_url_2;
    },

    async test(){


    },


    async save(){

      this.loading = true;
      let url = "";
      url = this.$url + '/rfidInfo/productUserUpate';

      const json = { 'auth_code': this.authCode
        ,'user_name' :this.userName
        ,'phone_number' : this.phoneNumber
        ,'email' : this.email
        ,'product_name' : this.productName
        , 'sale_name' : this.saleName
      };

      Axios.post(url
          , json
          , this.$store.state.config ).then(res => {

        let saveCount = res.data;
        this.loading = false;
        this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
        // this.search(false);

      }).catch(error => {
        console.log(error.response)
        this.$message.error(this.$store.state.serverErrorMessage);
        this.currentPage = 1;
        this.loading = false;
      }); // await Axios.post
    }, // save

    async chkQrCode(){
      this.loading = true;
      // default data
      let url = this.$url + '/rfidInfo/chkQrCode';
      var reqJson = new Object();
      reqJson.auth_code = this.authCode
      reqJson.latitude = this.latitude
      reqJson.longitude = this.longitude
      reqJson.formatted_address = this.formatted_address;
      reqJson.country = this.country;
      reqJson.administrative_area_level_1 = this.administrative_area_level_1;

      await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
        var resDataJson = res.data.rfidInfoDTO;

        for(var resData in resDataJson){
          this.authKey =  resDataJson[resData]['auth_key'];
          this.chkFlag =  resDataJson[resData]['chk_flag'];
          this.checkCount =  resDataJson[resData]['check_count'];
          // this.mainDiv = "mainBody" + ;
          this.rfidGetOrderSeq = resDataJson[resData]['rfid_get_order_seq'] *  1   ;

          this.failImage = "https://makesolutions.kr/fail_0.png"
          if (this.rfidGetOrderSeq > 0) {
            this.failImage = "https://makesolutions.kr/fail_" + resDataJson[resData]['rfid_get_order_seq'] + ".png"
          }

          //button_margin_top
          if (resDataJson[resData]['button_margin_top'] != null && resDataJson[resData]['button_margin_top'] != '') {
            this.deviceML = resDataJson[resData]['button_margin_top'];
          }

          //button_color
          if (resDataJson[resData]['button_color'] != null && resDataJson[resData]['button_color'] != '') {
            this.buttonColor = resDataJson[resData]['button_color'];
          }

          //button_border_color
          if (resDataJson[resData]['button_border_color'] != null && resDataJson[resData]['button_border_color'] != '') {
            this.buttonBoderColor = resDataJson[resData]['button_border_color'];
          }

          if (this.chkFlag == "false") {
            this.$message.success("가품으로 의심됩니다.");
            this.successFlag = false;
            this.failFlag = true;
          } else {
            this.$message.success("정품 입니다.");
            this.successFlag = true;
            this.failFlag = false;

            if (this.rfidGetOrderSeq == 2) {
              this.successFlag2 = true;
              this.successFlag3 = false;
              // this.deviceML = '15'
            } else {
              if (this.rfidGetOrderSeq == 5) {
                // this.deviceML = '100'
              }
              this.successFlag3 = true;
            }
          }

          this.link_message_1 =    resDataJson[resData]['link_message_1'];
          this.link_url_1 =    resDataJson[resData]['link_url_1'];
          this.link_message_2 =    resDataJson[resData]['link_message_2'];
          this.link_url_2 =    resDataJson[resData]['link_url_2'];
          this.dept_name =  resDataJson[resData]['dept_name'];


          if (  resDataJson[resData]['auth_gubun'] == '1' ) {
            this.authGubun1 =  true;

          }else if (  resDataJson[resData]['auth_gubun'] == '2' ) {

            // 첫번째 버튼 감추기
            //
            this.authGubun1 =  false;
            this.authGubun2Step1 = true;


            // if (this.chkFlag == "false") {
            //   this.$message.success("가품으로 의심됩니다.");
            //   this.$message.success("가품으로 의심됩니다.");
            //   this.successFlag = false;
            //   this.failFlag = true;
            //
            //   // this.successFlag = false;
            //   // this.authGubun2 = false;
            //   // this.failFlag = true;
            // } else {
            //   this.$message.success("정품 입니다.");
            //
            //   this.successFlag = true;
            //   this.failFlag = false;
            //
            //   // this.authGubun2 = true;
            //   //
            //   // this.failFlag = false;
            //   // this.deviceML = '70';
            // }

          } //


        }

        if (resDataJson == null)
        {
          this.$message.success("가품으로 의심됩니다.");
          this.failImage = "https://makesolutions.kr/fail_0.png";
          this.successFlag = false;
          this.authGubun2 = false;
          this.failFlag = true;
        }

        console.log ( "----------------mainDiv-------------------------" ) ;
        console.log ( this.mainDiv ) ;

        this.loading = false;

      }) // await Axios.post
          .catch(error => {

            this.successFlag = false;
            this.failFlag = true;

            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }); // await Axios.post
    },//chkQrCode




    async geolocate2() {
      navigator.geolocation.getCurrentPosition(position => {

        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;

        var lang = navigator.language;
        console.log(lang.toLowerCase());
        console.log(this.latitude);
        console.log(this.longitude)

        this.formatted_address  = "C69P+46P 중국 베이징 시 창핑 구임시"
        this.country=""
        this.administrative_area_level_1="베이징 시"
        this.chkQrCode();

      });

    },

    async geolocate() {
      navigator.geolocation.getCurrentPosition(position => {

        this.latitude =  position.coords.latitude;
        this.longitude = position.coords.longitude;

        var lang = navigator.language;
        console.log (lang.toLowerCase()) ;
        console.log (this.latitude) ;
        console.log (this.longitude) ;

        let url2  = "https://maps.googleapis.com/maps/api/geocode/json?latlng="+this.latitude +","+ this.longitude  +"&key=AIzaSyA1LUF3e_P4F_vrT24zIJDy9p96eRJQmdg&language=ko"

        if (lang.toLowerCase() == "zh-cn" || lang.toLowerCase()  == "zh-cn" || lang.toLowerCase()  == "zh-sg"  || lang.toLowerCase()  == "zh-sg"  || lang.toLowerCase()  == "zh-tw"
            || lang.toLowerCase()  == "zh"
        )
        {
          url2  = "http://maps.google.cn/maps/api/geocode/json?latlng="+this.latitude +","+ this.longitude  +"&key=AIzaSyA1LUF3e_P4F_vrT24zIJDy9p96eRJQmdg&language=ko"
        }



        // let url2  = "https://maps.googleapis.com/maps/api/geocode/json?latlng="+this.latitude +","+ this.longitude  +"&key=AIzaSyA1LUF3e_P4F_vrT24zIJDy9p96eRJQmdg&language=ko"
//https://maps.googleapis.com/maps/api/geocode/json?latlng=40.714224,-73.961452&key=AIzaSyBqTiTAdFgE-yTQ8_FHtm961uCL-DEWXAo


//         let url2  = "http://maps.google.cn/maps/api/geocode/json?latlng="+this.latitude +","+ this.longitude  +"&key=AIzaSyA1LUF3e_P4F_vrT24zIJDy9p96eRJQmdg&language=ko"
// //https://maps.googleapis.com/maps/api/geocode/json?latlng=40.714224,-73.961452&key=AIzaSyBqTiTAdFgE-yTQ8_FHtm961uCL-DEWXAo

        Axios.get(url2 ).then(res => {

          this.formatted_address = res.data['results'][0]['formatted_address'] ;
          for(var i=0 ; i< res.data['results'][0]['address_components'].length   ; i++) {
            if (res.data['results'][0]['address_components'][i]['types'][0] == "country")
              this.country= res.data['results'][0]['address_components'][i]['long_name']   ;

            if (res.data['results'][0]['address_components'][i]['types'][0] == "administrative_area_level_1")
              this.administrative_area_level_1 = res.data['results'][0]['address_components'][i]['long_name']  ;
          }

          this.chkQrCode();
        }) // await Axios.post
            .catch(error => {
              console.log(error.response)

            }); // await Axios.post
      });

    },

    Confirm(){
      this.dialogVisible = false
    },





  }
}
</script>


<style>

<!-- HTML !-->


#inputForm {
  width: 42vw !important;
}

#authResult {
  width: 300px !important;
}


.gifImage {
  /*background-image: url('https://makesolutions.kr/fail.png');*/
  margin-top: 10vh;
  margin-left: 32vw;
  background-size: cover;
  height: 35vh;
  width: 38vw;
  background-repeat: no-repeat;
  background-position: center;
}

.gifImage2 {
  /*background-image: url('https://makesolutions.kr/fail.png');*/
  margin-top: 5vh;
  margin-left: 32vw;
  background-size: cover;
  height: 35vh;
  width: 38vw;
  background-repeat: no-repeat;
  background-position: center;
}

.el-button--danger:focus, .el-button--danger:hover {
  background: #a8915f !important;
  border-color: #a8915f !important;
  /*color: #a8915f !important;*/
}

.el-button--danger {
  /*color: #a8915f !important;*/
  background-color: #a8915f !important;
  border-color: #a8915f !important;
}


/*.el-button--success:focus, .el-button--success:hover {*/
/*  background: #FF6D00 !important;*/
/*  border-color: #FF6D00 !important;*/
/*  !*color: #a8915f !important;*!*/
/*}*/

/*.el-button--success {*/
/*  !*color: #a8915f !important;*!*/
/*  background-color: #FF6D00 !important;*/
/*  border-color: #FF6D00 !important;*/
/*}*/


/*.el-button--mino:focus, .el-button--mino:hover {*/
/*  background: #FF6D00 !important;*/
/*  border-color: #FF6D00 !important;*/
/*  !*color: #a8915f !important;*!*/
/*}*/

/*.el-button--mino {*/
/*  !*color: #a8915f !important;*!*/
/*  background-color: #FF6D00 !important;*/
/*  border-color: #FF6D00 !important;*/
/*}*/


/*.el-button--successFlag8:focus, .el-button--successFlag8:hover {*/
/*  background: #C09884 !important;*/
/*  border-color: #C09884 !important;*/
/*  !*color: #a8915f !important;*!*/
/*}*/

/*.el-button--successFlag8 {*/
/*  !*color: #a8915f !important;*!*/
/*  background-color: #C09884 !important;*/
/*  border-color: #C09884 !important;*/
/*}*/




.failBody {
  /*background-image: url('https://makesolutions.kr/fail.png');*/
  background-size: cover;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
}

.box {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 350px;
}

.menu-button {
  text-align: center !important;
  justify-content: center !important;
  align-items: center !important;
  margin-bottom: 0px !important;
  width: 300px !important;
  height: 50px !important;
  border-radius: 4px !important;
  color: #fff !important;
  padding: 10px 20px !important;
  box-sizing: border-box !important;
}


#inputForm {
  justify-content: center !important;
  align-items: center !important;
  height: 30px !important;
  width: 160px !important;
  border: 1px solid #2C5AA0 !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
  font-size: 13px !important;
  padding: 0 6px !important;
}


</style>



